/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From
import Service from '@ember/service';
// Ember Imports
import { service } from '@ember/service';
// External Imports
import config from '@linc-technologies/linced-common/utils/config';

const qrModelName = 'auth/qr-code';

export default class HeroApiAuthService extends Service {
  @service
  fetch;

  @service
  store;

  /**
   * getQrCodes returns secure single use sign in qr codes for the specified
   * people.
   *
   * @param {String} schoolId - The school to generate qr codes for.
   * @param {String[]} personIds - The learners to generate sign in qr codes for.
   * @return {Promise<(DS.AdapterPopulatedRecordArray<module:@linc-technologies/linced-common/models/auth/qr-code>|null)>}
   */
  getQrCodes(schoolId, personIds) {
    if (personIds.length === 0) {
      return Promise.resolve(null, this.getQrCodes.name);
    }

    const uri = `${config.APP.apiHost}/auth/v4/qrcodes`;
    const payload = {
      schoolId,
      personIds,
    };
    const options = {
      data: JSON.stringify(payload),
    };
    return this.fetch.post(uri, options).then((res) => {
      let hasQrCodes = Object.hasOwn(res, 'qrCodes');
      if (!res || !hasQrCodes) {
        return Promise.resolve(null, this.getQrCodes.name);
      }

      let normalizedRecords = this._normaliseQrCodeResponse(res);
      return Promise.resolve(normalizedRecords, this.getQrCodes.name);
    });
  }

  /**
   * getMFAQrCodeAndSecret returns a secure single use sign in qr code for the current
   * person, and a secret that can be used for an authenticator app and for enrolment with FusionAuth.
   *
   * @return {Promise}
   */
  getMFAQrCodeAndSecret() {
    let uri = `${config.APP.apiHost}/auth/v4/mfa/:generateMFASecret`;
    return this.fetch
      .post(uri)
      .then((res) => {
        let normalizedRecord = this._normaliseQrCodeResponse(res);
        return {
          qrCode: normalizedRecord,
          secret: res.secretBase32,
        };
      })
      .catch((err) => {
        return err;
      });
  }

  /**
   * _normaliseQrCodeResponse normalizes a JSON QR Code payload to ember data
   * store models.
   *
   * @param {Object} payload - A JSON payload.
   * @return {DS.AdapterPopulatedRecordArray<module:@linc-technologies/linced-common/models/auth/qr-code>}
   * @private
   */
  _normaliseQrCodeResponse(payload) {
    // refer pushPayload deprecation: https://github.com/emberjs/rfcs/issues/357
    const modelClass = this.store.modelFor(qrModelName);
    const serializer = this.store.serializerFor(qrModelName);
    const jsonApiPayload = serializer.normalizeResponse(
      this.store,
      modelClass,
      payload,
      null,
      'query',
    );

    return this.store.push(jsonApiPayload);
  }
}
